import React, { Component } from 'react';
import './App.css';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import logo from "./Images/office-365.jpg";
import Header from "./Components/Header.jsx"
import AbacusSnackbar from './Components/AbacusSnackbar.jsx';
import {SSOUrl} from "./Config.jsx"

class Login extends Component {
  userName = "";
  constructor(props) {
    super(props);  

    props.data.Login.ErrorCallback = this.error.bind(this);
    props.data.Login.ShowLoginButton = this.showLoginButton.bind(this);

    this.state = {
      redirect: false,
      Snackbar_Open: false,
      Snackbar_ErrorText: "",
      showButtom: !props.data.Login.IsCodePresent
    }
  }

  style={
    width:"300px",
    marginTop:"50px"
  }

  showLoginButton(isShow){
    this.setState({
      showButtom: isShow
    })
  }

  error(message){
    this.setState({
      Snackbar_Open: true,
      Snackbar_ErrorText: message
    })
  }

  onClick(){
    window.location.replace(SSOUrl);
  }

  snackClick(){
    this.setState({
      Snackbar_Open: false,
      Snackbar_ErrorText: ""
    })
  }

  render() {
    return (
      <div>
        <Header isShowExit={false}></Header>
        <div className="inner_login_div">
          <img src={logo} alt="logo" style={{width:"200px",height:"120px"}}></img>
          <br></br>        
          <label>Single Sign-on with Microsoft Credentials is <br></br>available for all AbacusNext Monitor accounts.<br></br><br></br>Please login to your Office 365 account.</label>
          <br></br>
          {this.state.showButtom ? <Button onClick={this.onClick.bind(this)} style={this.style} variant="contained" color="primary">
            LOGIN TO OFFICE 365
          </Button>: <CircularProgress style={{marginTop:"50px"}} />}
          <AbacusSnackbar buttonStyle={{color:"red"}} open={this.state.Snackbar_Open} message={this.state.Snackbar_ErrorText} onClick={this.snackClick.bind(this)}></AbacusSnackbar>
        </div>
      </div>
    );
  }
}

export default Login;